import {handleError} from "../../../helpers/handleError";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";

const forgetPassword = {
    namespaced: true,
    state: {
        forgetIsFetching: false,
        modalData: {},
        isUserForgetPassword: false
    },
    mutations: {
        FORGET_SUCCESS(state, response) {
            state.modalData.headInfoForgetPassword = response.data.message;
            state.modalData.textInfoForgetPassword = response.data.data.textInfo;
            state.modalData.typeInfoForgetPassword = "green";
            state.isUserForgetPassword = true;
            },

        FORGET_FAILURE(state, error) {
            state.modalData.headInfoForgetPassword = error.response.data.message;
            state.modalData.textInfoForgetPassword =  handleError(error) !== "" ? handleError(error) : error.response.data.data.textInfo;
            state.modalData.typeInfoForgetPassword = "red";
            state.isUserForgetPassword = true;
            eventBus.$emit("forgetPasswordFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isUserForgetPassword = value;
        }
    },
    actions: {
        forgetPassword({dispatch, state}, payload) {
            dispatch("requestForget");
            var promise = sendRequest("post", config.baseURLApi+'/users/reset-password', {}, payload.creds, false);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("successForget", $result[1]);
                } else {
                    dispatch("failureForget", $result[1]);
                }
                state.forgetIsFetching = false;
            });
        },
        requestForget({state}) {
            state.forgetIsFetching = true;
        },
        successForget({ commit }, response) {
            commit("FORGET_SUCCESS", response);
        },
        failureForget({ commit }, error) {
            commit("FORGET_FAILURE", error);
        },
        updateVisibleModal(context, value) {
            context.commit('UPDATE_VISIBLE_MODAL', value)
        }
    },

}

export default forgetPassword